export default __webpack_public_path__ + "static/media/bake-white-logo-with-text.cee3a84b.svg";